export default __webpack_public_path__ + "static/media/Jithin Sabu.02f6e4cf.jpg";